<script>
export let headline;
export let description;
export let image;
export let video;
export let what;
export let tools;
export let where;
export let maxWidth;
</script>

<style>
.LinkLayoutB video, 
.LinkLayoutB img {
    float: right;
    width: 33%;
    margin-right: 0px;
    margin-top: 0px;
}
</style>

<div class="LinkLayoutB">
    <div class="headline">{headline}</div>
    {#if image}
        <img src="{image}" alt="Promo for {headline}" style="max-width: {maxWidth}px"/>
    {:else if video}
        <video inline muted autoplay loop src="{video}" style="max-width: {maxWidth}px"></video>
    {/if}
    <div class="description">{description}</div>
    {#if what}
        <div class="what"><b>What I did:</b> {what}</div>
    {/if}
    {#if where}
        <div class="where"><b>Where:</b> {where}</div>
    {/if}
    {#if tools}
        <div class="tools"><b>Tools:</b> {tools}</div>
    {/if}
    <div class="clear"></div>
</div>